// The theme's colours for code that can't read custom properties: the canvas and the sprite worker (design 15 §4.1).
// The values are src/theme.gen.json, written by scripts/theme.mjs from theme/theme.mjs, the same as tokens.css's.

import theme from "./theme.gen.json";

export type Role = keyof typeof theme.colours;

/** The theme's version: a sheet drawn in one theme is drawn again in another. */
export const THEME_ID: string = theme.id;

/** A role's colour, as a hex. */
export const colour = (role: Role): string => theme.colours[role];

/** A role's colour as red, green and blue (0–255). */
export const rgbOf = (role: Role): number[] => [1, 3, 5].map((i) => parseInt(theme.colours[role].slice(i, i + 2), 16));

/** Red, green and blue as a CSS colour, at an opacity. */
export const css = (rgb: readonly number[], alpha = 1): string => `rgba(${rgb.map((v) => Math.round(v)).join(", ")}, ${alpha})`;
